import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { heading4, defaultFontStack } from "../../../../styles/typography/v2";

const Root = styled.h4(defaultFontStack, heading4, {
  margin: 0,
  padding: 0,
});

function Heading4(props) {
  const { className, children, style, id } = props;
  return (
    <Root
      id={id}
      data-component-name="heading4"
      className={className}
      style={{ color: style?.textColor }}
    >
      {children}
    </Root>
  );
}

Heading4.propTypes = {
  children: PropTypes.node.isRequired,
  style: PropTypes.shape({
    textColor: PropTypes.string,
  }),
};

export default Heading4;
